import { useSchedulersGetSchedulerProfile } from '@cocoonspace/api'
import { useParams } from 'next/navigation'

import { PoweredBy } from '../powered-by'
import { AnswerCard } from './answer-card'

export const SchedulingAnswerPageContent = ({
	idOrSlug,
	embedded = false,
	successPath,
	profileSlug,
}: {
	idOrSlug: string
	embedded?: boolean
	successPath?: string
	profileSlug?: string
}) => {
	const { data: profile } = useSchedulersGetSchedulerProfile(
		profileSlug ?? '',
		{ query: { enabled: !!profileSlug, retry: false } },
	)
	const backgroundImageUrl = profile?.styles?.backgroundImageUrl

	return (
		<div
			className='relative flex min-h-screen flex-1 flex-col items-center justify-center gap-4 bg-cover bg-center px-4 py-8 max-md:px-0 max-md:py-0'
			style={
				backgroundImageUrl
					? { backgroundImage: `url("${encodeURI(backgroundImageUrl)}")` }
					: undefined
			}
		>
			<div className='relative flex w-full max-w-6xl flex-col items-center gap-4'>
				<AnswerCard
					idOrSlug={idOrSlug}
					embedded={embedded}
					successPath={successPath}
					profile={profile}
				/>
				<PoweredBy alt={!!backgroundImageUrl} />
			</div>
		</div>
	)
}

export const SchedulingAnswerPage = () => {
	const { slugOrId, userSlug } = useParams<{
		slugOrId: string
		userSlug?: string
	}>()

	return (
		<SchedulingAnswerPageContent
			idOrSlug={slugOrId}
			profileSlug={userSlug}
		/>
	)
}
